export default {
  title: 'Meine Kurse',
  searchPH: 'Suche nach Kursnamen',
  noCourses: 'Keine Kurse gefunden'
}



// WEBPACK FOOTER //
// ./src/i18n/courses/de.js